const usedLanguage = (language: string) => {
    
    if (['en', 'fr', 'mg'].includes(language?.toLowerCase())) {
        return language?.toLowerCase();
    }


    return 'en';
};

export default usedLanguage;